export const commonEventWrap = (eventId, time, titleText, descriptionText, actionIconUrl, eventDetails='', optionalClass = '') => `
<div class="event-item ${optionalClass}" id="${eventId}">
    <div class="event-icon"><img src="${actionIconUrl}" /></div>
    <time datetime="">${time}</time>
    <h3 class="event-title">${titleText}</h3>
    <div class="event-description">${descriptionText}</div>
    ${eventDetails}
</div>`